<template>
	<div class="customTempArea">
		<div class="fieldDiv_top FlexBetween">
			<div class="Title_back FlexAlign">
				<el-button @click.native="ToRoute_info_div">
					<i class="el-icon-arrow-left"></i>
				</el-button>
				<span>{{ title || "" }}</span>
			</div>
			<div class="field_submit FlexAlign">
				<el-button class="savebtn" @click.native="saveFieldInfo">保存</el-button>
				<el-button class="cancel" @click.native="ToRoute_info_div">取消</el-button>
			</div>
		</div>
		<div class="field_content FlexBox FlexJusBetween">

			<div class="field_div_left">
				<div class="tit">基础字段</div>
				<div class="MoreModule FlexWrap" id="MoreAddItems">
					<el-button class="options" :data-index="ind" v-for="(sel, ind) in feild_select">
						{{sel.title || ''}}
					</el-button>
				</div>
			</div>

			<div class="fieldFromBox" id="MobileBox">

				<div class="field_from_module" :class="['not-sort-box']">
					<div class="field_tit">表头展示</div>
					<div class="field_group" id="tableSort">

						<template v-for="(item1, index) in sortList">
							<div class="field_item" v-if="item1.value.is_table == 1 && item1.value.table_sort != 0"
								:data-table_sort="item1.value.table_sort" :key="item1.id">
								<label class="tit">{{ item1.value.field }} </label>
								<el-input v-if="item1.value.field_type === 1" class="input_w460"
									v-model="item1.value.value" disabled :placeholder="item1.value.placeholder"
									:maxlength="item1.value.maxLength"></el-input>

								<el-input v-else-if="item1.value.field_type === 2" class="input_w460"
									v-model="item1.value.value" disabled :placeholder="item1.value.placeholder"
									:maxlength="item1.value.maxLength" type="textarea" :rows="1"></el-input>

								<el-date-picker v-else-if="item1.value.field_type === 3" v-model="item1.value.value"
									disabled value-format="timestamp" type="date" :placeholder="item1.value.placeholder"
									class="input_w460">
								</el-date-picker>

								<el-input v-else-if="item1.value.field_type === 4" :maxlength="item1.value.maxLength"
									v-model="item1.value.value" disabled :placeholder="item1.value.placeholder"
									class="input_w460">
								</el-input>

								<el-select v-else-if="item1.value.field_type === 5" v-model="item1.value.value" disabled
									:placeholder="item1.value.placeholder" class="input_w460">
									<el-option v-for="item2 in item1.value.field_config.list" :key="item2.id"
										:label="item2.name" :value="item2.id">
									</el-option>
								</el-select>

								<el-select v-else-if="item1.value.field_type === 6" multiple collapse-tags
									v-model="item1.value.value" disabled :placeholder="item1.value.placeholder"
									class="input_w460">
									<el-option v-for="item2 in item1.value.field_config.list" :key="item2.id"
										:label="item2.name" :value="item2.id">
									</el-option>
								</el-select>

							</div>
						</template>

					</div>
				</div>

				<div class="field_from_module" v-for="item in cuitemsList" :key="item.type"
					:class="[item.type == 1 ? 'not-sort-box' : '']">
					<div class="field_tit">
						{{ typeFontList[item.type - 1] }}
					</div>

					<div class="field_group" :ref="item.type" :data-ref="item.type">
						<div v-for="item1 in item.list" :key="item1.id" :data-id="item1.id" :data-ref="item.type"
							class="field_item" :class="item1.is_move == 1 || item1.is_state == 0 ? 'not-sort' : ''"
							:style="itemsConfig.id === item1.id ? 'background-color: #eff3fd;': ''"
							@click="handleClick(item1)">
							<label class="tit">
								{{ item1.field }}{{ item1.is_state == 0 ? "（未启用）" : ""}}
								<i v-if="item1.required === 1">*</i>
							</label>

							<el-input v-if="item1.field_type === 1" :class="backWidth(item1.length)"
								v-model="item1.value" disabled :placeholder="item1.placeholder"
								:maxlength="item1.maxLength"></el-input>

							<el-input v-else-if="item1.field_type === 2" :class="backWidth(item1.length)"
								v-model="item1.value" disabled :placeholder="item1.placeholder"
								:maxlength="item1.maxLength" type="textarea" :rows="1"></el-input>
							<el-date-picker v-else-if="item1.field_type === 3" v-model="item1.value" disabled
								value-format="timestamp" type="date" :placeholder="item1.placeholder"
								:class="backWidth(item1.length)">
							</el-date-picker>
							<el-input v-else-if="item1.field_type === 4" :maxlength="item1.maxLength"
								v-model="item1.value" disabled :placeholder="item1.placeholder"
								:class="backWidth(item1.length)">
							</el-input>
							<el-select v-else-if="item1.field_type === 5" v-model="item1.value" disabled
								:placeholder="item1.placeholder" @focus="handleClick(item1)"
								:class="backWidth(item1.length)">
								<el-option v-for="item2 in item1.field_config.list" :key="item2.id" :label="item2.name"
									:value="item2.id">
								</el-option>
							</el-select>
							<el-select v-else-if="item1.field_type === 6" multiple collapse-tags v-model="item1.value"
								disabled :placeholder="item1.placeholder" @focus="handleClick(item1)"
								:class="backWidth(item1.length)">
								<el-option v-for="item2 in item1.field_config.list" :key="item2.id" :label="item2.name"
									:value="item2.id">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>

			</div>

			<div class="setting_plate" v-show="itemsConfig.id">
				<div class="show_name">
					编辑字段
					<span>
						({{editFeildTitle}})
					</span>
				</div>

				<div class="setting_info">
					<div class="setting_item">
						<label class="setting_tit"> 标题 </label>

						<el-input :disabled="itemsConfig.lock === 1" style="width: 223px"
							:class="{'rules': !rulesField.field}" v-model="itemsConfig.field" @input="checkRules">
						</el-input>
						<div v-show="!rulesField.field" style="color: red">
							请检查标题
						</div>
					</div>
					<div class="setting_item">
						<label class="setting_tit">提示</label>
						<el-input style="width: 223px" v-model="itemsConfig.placeholder"></el-input>
					</div>
					<div class="setting_item">
						<label class="setting_tit">默认内容</label>

						<el-input v-if="itemsConfig.field_type === 1" style="width: 223px" v-model="itemsConfig.value"
							:placeholder="itemsConfig.placeholder" :maxlength="itemsConfig.maxLength">
						</el-input>

						<el-input v-else-if="itemsConfig.field_type === 2" style="width: 223px"
							v-model="itemsConfig.value" :placeholder="itemsConfig.placeholder"
							:maxlength="itemsConfig.maxLength" type="textarea" :rows="1">
						</el-input>

						<el-date-picker v-else-if="itemsConfig.field_type === 3" v-model="itemsConfig.value"
							value-format="timestamp" type="date" :placeholder="itemsConfig.placeholder"
							style="width: 223px">
						</el-date-picker>

						<el-input v-else-if="itemsConfig.field_type === 4" :maxlength="itemsConfig.maxLength"
							v-model="itemsConfig.value" :placeholder="itemsConfig.placeholder" style="width: 223px">
						</el-input>

						<el-select v-else-if="itemsConfig.field_type === 5" v-model="itemsConfig.value"
							style="width: 223px" :placeholder="itemsConfig.placeholder">
							<el-option v-for="item2 in itemsConfig.field_config.list" :key="item2.id"
								:label="item2.name" :value="item2.id">
							</el-option>
						</el-select>

						<el-select v-else-if="itemsConfig.field_type === 6" multiple collapse-tags
							v-model="itemsConfig.value" style="width: 223px" :placeholder="itemsConfig.placeholder">
							<el-option v-for="item2 in itemsConfig.field_config.list" :key="item2.id"
								:label="item2.name" :value="item2.id">
							</el-option>
						</el-select>

					</div>
					<div class="setting_item" v-show="itemsConfig.field_type === 5 || itemsConfig.field_type === 6">
						<label class="setting_tit">自定义选项</label>
						<div id="sort_option">
							<template v-if="itemsConfig.field_type === 5 || itemsConfig.field_type === 6">
								<div v-for="value in itemsConfig.field_config.list" :key="value.id" class="option">
									<el-input :disabled="itemsConfig.is_move === 1" placeholder="选项名称"
										v-model="value.name" maxlength="10" style="margin-bottom: 10px">
										<el-button :disabled="itemsConfig.is_move === 1" slot="suffix" class="del"
											@click="delOption(value.id)">
											<a title="删除">
												<i class="el-icon-delete" style="font-size: 14px"></i>
											</a>
										</el-button>
										<el-button slot="suffix" class="sort">
											<a title="拖动排序">
												<i class="el-icon-sort" style="font-size: 14px"></i>
											</a>
										</el-button>
									</el-input>
								</div>
							</template>
						</div>

						<el-button class="add_btn" @click="addOption" :disabled="itemsConfig.is_move === 1">+
							添加新选项
						</el-button>
					</div>
					<div class="setting_item">
						<label class="setting_tit">字段占比%</label>
						<el-radio-group v-model="itemsConfig.length" :disabled="itemsConfig.is_move === 1">
							<el-radio-button :label="1">25</el-radio-button>
							<el-radio-button :label="0">50</el-radio-button>
							<el-radio-button :label="2">75</el-radio-button>
							<el-radio-button :label="3">100</el-radio-button>
						</el-radio-group>
					</div>
					<div class="setting_item">
						<el-checkbox v-model="itemsConfig.required" :disabled="itemsConfig.is_move === 1"
							:true-label="1" :false-label="0">
							这个是必填项
						</el-checkbox>
					</div>
					<div class="setting_item">
						<el-checkbox v-model="itemsConfig.is_table" :true-label="1" :false-label="0"
							@change="changTable">
							表头显示
						</el-checkbox>
					</div>
					<div class="setting_item">
						<el-checkbox v-model="itemsConfig.is_state" :disabled="itemsConfig.is_move === 1"
							:true-label="1" :false-label="0" @change="changeState">
							启用字段
						</el-checkbox>
					</div>
					<div class="setting_item">
						<el-checkbox v-model="itemsConfig.is_move" :true-label="1" :false-label="0">
							is_move
						</el-checkbox>
					</div>
					<div class="setting_item">
						<el-checkbox v-model="itemsConfig.lock" :true-label="1" :false-label="0">
							lock
						</el-checkbox>
					</div>
					<div class="setting_item">
						<el-button :disabled="itemsConfig.lock === 1"
							@click="deleteFieldShow(itemsConfig.type, itemsConfig.id)">
							删除字段
						</el-button>
					</div>
				</div>
			</div>

		</div>

		<!-- 删除字段 -->
		<div class="deleteField">
			<el-dialog title="删除字段" :visible.sync="setting_show" width="400px" @before-close="deleteFieldClose()">
				确认删除
				<span class="text-red">{{ itemsConfig.field }}</span>
				字段吗？
				<span slot="footer">
					<el-button class="delbtn" @click="fndeleteField">删除</el-button>
				</span>
			</el-dialog>
		</div>

	</div>
</template>

<script>
	import Sortable from "sortablejs";
	import {
		updata_customer_form,
		get_customer_form_id,
	} from "network/hk_customer";
	import {
		External_left_list,
		External_feildSelect,
	} from "./js/cuField.js"
	export default {
		data() {
			return {
				form_id: 0,
				title: "",
				itemsConfig: {},
				setting_show: false,
				delFieldInfo: {
					type: null,
					id: null,
				},
				leftList: [],
				cuitemsList: [],

				// 记录当前最大的id值
				maxId: 0,
				// 校验编辑字段
				rulesField: {
					all: true,
					field: true,
				},
				// 表头设置
				sortList: [],
				sortId: 0,
				// 删除后的字段配置
				delItems: [],
				typeFontList: [
					'基础信息', '联系信息', '身份信息', '企业信息',
				],
				feild_select: [],
				
			};
		},
		computed: {
			editFeildTitle() {
				if (!this.feild_select.length) return
				if (this.feild_select[this.itemsConfig.field_type]) {
					return this.feild_select[this.itemsConfig.field_type].title || ''
				}
			},
		},
		created() {
			this.leftList = External_left_list
			this.feild_select = External_feildSelect
			let {
				form_id,
				title,
				projcet_div_id
			} = this.$route.query;
			this.form_id = form_id * 1;
			this.title = title;
			this.initialization(projcet_div_id)
		},
		methods: {
			backWidth(flag) {
				return flag === 1 ? 'input_w230' : flag === 0 ? 'input_w460' : flag === 2 ? 'input_w690' : flag === 3 ?
					'input_w920' : 'input_w460'
			},
			initialization(projcet_div_id) {
				get_customer_form_id(this.form_id, 2, projcet_div_id).then((res) => {
					if (!this.$handlereq(res)) return
					let resArr = res.result;
					this.getFieldConfig(resArr);
				});
				this.leftList.forEach((ele) => {
					ele.module_detail_type = this.form_id;
					ele.projcet_div_id = projcet_div_id
				});
			},
			// 获取模块字段配置
			getFieldConfig(resArr) {
				resArr.forEach((item, index) => {
					if (item.field_config === "") {
						item.field_config = '{"list":[]}';
					}
					item.field_config = JSON.parse(item.field_config);
					if (item.field_type === 5) {
						if (item.value !== "") {
							item.value = item.value * 1;
						}
					}
					if (item.field_type === 6) {
						if (item.value !== "") {
							item.value = item.value.split(",");
							item.value.forEach((ele, i) => {
								item.value[i] = parseInt(ele);
							});
						}
					}
					if (item.id > this.maxId) {
						this.maxId = item.id;
					}
					item.operate = 1
				});

				this.cuitemsList = resArr.reduce((groups, item) => {
					const fvalgroup = groups.find((group) => group.type === item.type);
					if (fvalgroup) {
						fvalgroup.list.push(item);
					} else {
						groups.push({
							type: item.type,
							list: [item],
						});
					}
					return groups;
				}, []);
				this.itemsConfig = this.cuitemsList[0].list[0]
				// 获取表头信息排序
				this.changTable()
				setTimeout(() => {
					this.createMobileBlock()
				}, 500)
			},
			// 表头显示和排序
			changTable() {
				this.sortList = [];
				this.cuitemsList.forEach((item, itemindex) => {
					item.list.forEach((ele, eleindex) => {
						if (ele.is_table == 1) {
							this.sortList.push({
								id: this.sortId++,
								value: ele
							});
						} else {
							ele.table_sort = 0;
						}
					});
				});
				if (this.sortList.length > 1) {
					this.sortList.sort((a, b) => a.value.table_sort - b.value.table_sort);
				}
				if (this.sortList.length >= 1) {
					let maxSort = this.sortList[this.sortList.length - 1].value.table_sort + 1;
					this.sortList.forEach((item) => {
						if (item.value.table_sort == 0) {
							item.value.table_sort = maxSort;
						}
					});
				}
				if (this.sortList.length > 1) {
					this.sortList.sort((a, b) => a.value.table_sort - b.value.table_sort);
				}
			},
			// 
			createMobileBlock() {
				if (!this.cuitemsList.length) return
				for (let i = 0; i < this.cuitemsList.length; i++) {
					const sortableEl = this.$refs[this.cuitemsList[i].type][0]
					new Sortable(sortableEl, {
						// 左侧拖拽添加字段
						onAdd: (event) => {
							if (event.item.dataset.index !== undefined) {
								const item = JSON.parse(
									JSON.stringify(this.leftList[event.item.dataset.index])
								);
								const index = this.cuitemsList.findIndex(
									(element) => element.type == event.to.dataset.ref
								);
								item.id = this.maxId + 1;
								item.type = event.to.dataset.ref * 1;
								this.maxId++;
								this.cuitemsList[index].list.splice(event.newIndex, 0, item);
								this.itemsConfig = item;
								event.item.parentNode.removeChild(event.item);
							}
						},
						onMove: (event) => {
							// 禁止影响不可拖动的字段
							if (event.related.classList.contains("not-sort")) {
								return false;
							}
						},
						onEnd: (event) => {
							const index = this.cuitemsList.findIndex(
								(element) => element.type == event.item.dataset.ref
							);
							const toindex = this.cuitemsList.findIndex(
								(element) => element.type == event.to.dataset.ref
							);
							// 跨分类拖拽排序
							if (event.item.dataset.ref !== event.to.dataset.ref) {
								const item = this.cuitemsList[index].list.splice(event.oldIndex, 1)[0];
								item.type = event.to.dataset.ref * 1;
								this.cuitemsList[toindex].list.splice(event.newIndex, 0, item);
							}
							// 同分类拖拽排序
							else {
								const item = this.cuitemsList[index].list.splice(event.oldIndex, 1)[0];
								this.cuitemsList[index].list.splice(event.newIndex, 0, item);
							}
						},
						filter: ".not-sort",
						group: "shared",
						animation: 150,
					});
				}
				// 表头信息拖拽排序
				new Sortable(tableSort, {
					animation: 150,
					onEnd: (event) => {
						const item = this.sortList.splice(event.oldIndex, 1)[0];
						this.sortList.splice(event.newIndex, 0, item);
						this.sortList.forEach((ele, index) => {
							ele.value.table_sort = index + 1
						})
					},
				});
				// 分类拖拽排序
				new Sortable(MobileBox, {
					ghostClass: "sortable-ghost",
					// 不可拖拽项
					filter: ".not-sort-box",
					animation: 150,
					scroll: true,
					scrollSensitivity: 500,
					scrollSpeed: 50,
					bubbleScroll: true,
					onMove: (event) => {
						// 不可拖拽项
						if (event.related.classList.contains("not-sort-box")) {
							return false;
						}
					},
					onEnd: (event) => {
						const item = this.cuitemsList.splice(event.oldIndex - 1, 1)[0];
						this.cuitemsList.splice(event.newIndex - 1, 0, item);
					},
				});
				// 左侧字段可拖拽添加  MoreAddItems： dom id
				let isMove = false;
				new Sortable(MoreAddItems, {
					group: {
						name: "shared",
						pull: "clone",
						put: false,
					},
					onMove: (event) => {
						if (event.related.classList.contains("not-sort")) {
							return false;
						}
					},
					onChoose: (event) => {
						isMove = false;
					},
					onClone: (event) => {
						isMove = true;
					},
					onUnchoose: (event) => {
						// 点击按钮添加字段
						if (!isMove) {
							this.addField(event.item.dataset.index);
							isMove = false;
						}
					},
					animation: 150,
					sort: false,
				});
				// 字段选择项排序  sort_option : dom id
				new Sortable(sort_option, {
					ghostClass: "sortable-ghost",
					handle: ".el-icon-sort",
					animation: 150,
					onEnd: (event) => {
						const item = this.itemsConfig.field_config.list.splice(
							event.oldIndex,
							1
						)[0];
						this.itemsConfig.field_config.list.splice(event.newIndex, 0, item);
					},
				});
			},
			// 点击添加字段
			addField(type) {
				const item = JSON.parse(JSON.stringify(this.leftList[type]));
				item.id = this.maxId + 1;
				this.maxId++;
				const index = this.cuitemsList.findIndex((ele) => {
					return ele.type === 1;
				});
				this.cuitemsList[index].list.push(item);
				this.itemsConfig = item;
			},
			// 字段添加选项
			addOption() {
				let maxid = 0;
				this.itemsConfig.field_config.list.forEach((item) => {
					if (item.id > maxid) {
						maxid = item.id;
					}
				});
				let item = {
					id: 0,
					name: "未命名",
				};
				item.id = maxid + 1;
				this.itemsConfig.field_config.list.push(item);
			},
			// 字段选项删除
			delOption(id) {
				let index = this.itemsConfig.field_config.list.findIndex((element) => {
					return element.id === id;
				});
				this.itemsConfig.field_config.list.splice(index, 1);
			},
			// 字段删除弹窗打开
			deleteFieldShow(type, id) {
				this.delFieldInfo.type = type;
				this.delFieldInfo.id = id;
				this.setting_show = true;
			},
			// 字段删除弹窗关闭
			deleteFieldClose() {
				this.setting_show = false;
				this.delFieldInfo.type = null;
				this.delFieldInfo.id = null;
			},
			// 字段删除
			fndeleteField() {
				let index = this.cuitemsList.findIndex((element) => {
					return element.type === this.delFieldInfo.type;
				});
				let fieldIndex = this.cuitemsList[index].list.findIndex((ele) => {
					return ele.id === this.delFieldInfo.id;
				});
				let item = this.cuitemsList[index].list.splice(fieldIndex, 1)[0];
				if (item.operate === 1) {
					item.operate = 3
					item.sort = 0
					this.delItems.push(item)
					this.itemsConfig = this.cuitemsList[0].list[0];
					this.changTable()
				}
				this.deleteFieldClose();
			},
			// 选择字段编辑
			handleClick(value) {
				this.checkRules();
				if (!this.rulesField.field) {
					this.$alertMess('请检查标题', 'error')
					return
				}
				this.itemsConfig = value;
			},
			// 编辑字段表单验证
			checkRules() {
				if (this.itemsConfig.field === "") {
					this.rulesField.field = false;
				} 
				else if (this.itemsConfig.is_move != 1) {
					let arr = ["客户编号", "客户模块", "客户名称", "客户类型"];
					// 查找arr 是否包含 field:
					// if (arr.includes(this.itemsConfig.field)) {
					// 	this.rulesField.field = false;
					// } else {
					// 	this.rulesField.field = true;
					// }
					if (!arr.includes(this.itemsConfig.field)) {
						this.rulesField.field = true;
					}
				} 
				else {
					this.rulesField.field = true;
				}
			},
			// 保存模块表单
			saveFieldInfo() {
				this.checkRules();
				if(!this.rulesField.field) {
					this.$alertMess('请检查标题', 'error')
					return
				}
				let arr = [];
				let sort = 1
				this.cuitemsList.forEach((element) => {
					element.list.forEach((ele) => {
						ele.sort = sort++
						const item = JSON.parse(JSON.stringify(ele));
						if (item.field_type == 6) {
							item.value = item.value.join(",");
						}
						arr.push(item);
					});
				});
				if (this.delItems.length) {
					this.delItems.forEach((ele) => {
						const item = JSON.parse(JSON.stringify(ele));
						if (item.field_type == 6) {
							item.value = item.value.join(",");
						}
						arr.push(item);
					})
				}
				let data = {
					form_id: this.form_id,
					form_data: [],
				};
				data.form_data = JSON.stringify(arr);
				updata_customer_form(data).then((res) => {
					if(!this.$handlereq(res)) return
					this.$alertMess(res.message)
					this.ToRoute_info_div()
				});
			},
			ToRepRoute(path) {
				this.$router.replace(path).catch((err) => err);
			},
			ToRoute_info_div(){
				this.$router.replace("/set_up/kehu_set/customer_info_div").catch((err) => err);
			},
			// 字段启用状态
			changeState() {
				let index1 = this.cuitemsList.findIndex((ele) => {
					return ele.type == this.itemsConfig.type;
				});
				let cuseList = this.cuitemsList[index1].list
				let index2 = cuseList.findIndex((ele) => {
					return ele.id == this.itemsConfig.id;
				});
				const citem = cuseList.splice(index2, 1)[0]
				let index3 = cuseList.length - 1 || 0
				if (this.itemsConfig.is_state != 0) {
					let indexlast = true;
					cuseList.some((ele, index) => {
						index3 = index;
						if (ele.is_state == 0) {
							indexlast = false;
							return true;
						}
					});
					if (indexlast) {
						index3 = cuseList.length;
					}
				}
				cuseList.splice(index3, 0, citem);
			},
		},
	};
</script>

<style scoped lang="scss">
	@import "./css/cuField.scss";
</style>